import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UtilisateurDto } from '../dto/utilisateur-dto';
import { UtilisateurSaveDto } from '../dto/utilisateur-save-dto';

@Injectable({
  providedIn: 'root'
})
export class UtilisateursService {

  private readonly utilisateursBaseUrl = `${environment.baseUrl}/utilisateurs`;

  constructor(private http: HttpClient) {}

  getAllUtilisateurs(): Observable<UtilisateurDto[]> {
    const url = `${this.utilisateursBaseUrl}/getAllUtilisateurs`;
    return this.http.get<UtilisateurDto[]>(url);
  }

  createUtilisateur(utilisateur: UtilisateurSaveDto): Observable<UtilisateurSaveDto> {
    const url = `${this.utilisateursBaseUrl}/create`;
    return this.http.post<UtilisateurSaveDto>(url, utilisateur);
  }

  editUtilisateur(utilisateur: UtilisateurSaveDto, id: number): Observable<UtilisateurSaveDto> {
    const url = `${this.utilisateursBaseUrl}/edit/${id}`;
    return this.http.put<UtilisateurSaveDto>(url, utilisateur);
  }

  updateUtilisateur(utilisateur: UtilisateurDto): Observable<UtilisateurDto> {
    const url = `${this.utilisateursBaseUrl}/update`;
    return this.http.put<UtilisateurDto>(url, utilisateur);
  }

  deleteUtilisateur(id: number): Observable<void> {
    const url = `${this.utilisateursBaseUrl}/delete/${id}`;
    return this.http.delete<void>(url);
  }
}
